import React from "react";
import Item from "./Item";
import cx from "classnames";
import styles from "./Exploration.module.scss";
import Button from "@components/Button";
import Link from "@components/Link";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";

interface IProps {
  heading: string | React.ReactNode;
  items: {
    image: { src: string; alt: string };
    title: string | React.ReactNode;
    topic: string | React.ReactNode;
    description: string | React.ReactNode;
  }[];
}

export default function Exploration({ heading, items }: IProps) {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  return (
    <div className={cx(styles.section, "gap-12")}>
      <div className={cx(styles.heading)}>{heading}</div>
      <div className={cx(styles.wrapperItems)}>
        {items.map((item: any, index) => (
          <Item key={index} data={item} />
        ))}
      </div>
      <div className={cx(styles.button)}>
        <Link href={router.toUrl("stories")}>
          <Button
            className={styles.btn}
            label={i18n.t("Button.exploreMore")}
            color="black"
            dark
          />
        </Link>
      </div>
    </div>
  );
}
